import { where, type QueryConstraint } from "firebase/firestore";

/**
 * Classifications visible without the restricted-view permission. Mirrors
 * firebase/firestore.rules `match /evidence/{evidenceId}`.
 */
export const OPEN_CLASSIFICATIONS = ["public", "internal", "confidential"] as const;

/**
 * A Firestore *list* query is denied wholesale unless the query's own filters
 * provably satisfy the security rule for every possible matching document —
 * unlike a single-doc get, the rule engine won't evaluate per-document here.
 * The evidence rule allows a doc when its classification is one of
 * OPEN_CLASSIFICATIONS OR the reader holds evidence.restricted.view; a query
 * with no classification filter can't prove that, so Firestore rejects the
 * whole query for the 7 of 12 roles that lack the permission — even before
 * checking what's actually in the collection.
 *
 * Constrain the query itself: full access skips the filter (any classification
 * is theirs to see), everyone else is explicitly scoped to the open set.
 */
export function evidenceVisibilityConstraint(canSeeRestricted: boolean): QueryConstraint[] {
  return canSeeRestricted ? [] : [where("classification", "in", [...OPEN_CLASSIFICATIONS])];
}
